// hnb-frontend/src/auth/PublicOnlyRoute.tsx

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { getPostLoginRoute } from './AuthProvider';

type PublicOnlyRouteProps = {
  children: React.ReactElement;
};

function FullScreenLoader() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        background: '#f7f8fa',
        color: '#374151',
        fontSize: '0.95rem',
      }}
    >
      Loading...
    </div>
  );
}

export default function PublicOnlyRoute({
  children,
}: PublicOnlyRouteProps) {
  const { user, sessionLoading } = useAuth();

  if (sessionLoading) {
    return <FullScreenLoader />;
  }

  if (user) {
    return <Navigate to={getPostLoginRoute(user)} replace />;
  }

  return children;
}